import CustomRoute from './custom-route';

export default CustomRoute;